<template>
  <div id="ProjBidNewPurchaseList">
    <ProjBidNewHeader/>
    <ProjectViewSummary :project="project" class="panel-box"/>
    <div class="eb-line"></div>
    <ProjectEditHandsontable
      :isAfterRenderer="true"
      title="1 分项报价表"
      :hotSettings="initHotSettings"
      @removeRowEvent="removeRowEvent"
      addRowName="projbidNewPurchaselistAddRow"
      class="panel-box"
    />
    <div class="eb-line"></div>
    <ProjectEditComment class="panel-box" title="2 报价表备注" :project="project"/>
    <div class="eb-line"></div>
    <div class="eb-button-group">
      <el-button
        :loading="buttonLoading"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        @click="validateBeforeSave(false)"
      >保存草稿</el-button>
      <el-button
        :loading="buttonLoading"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        @click="validateBeforeSave(true, true)"
      >&lt; 采购规则</el-button>
      <el-button
        :loading="buttonLoading"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        @click="validateBeforeSave(true, false)"
      >选择供应商 &gt;</el-button>
    </div>
  </div>
</template>

<script>
import ProjBidNewHeader from '@/components/project/bid/new/ProjBidNewHeader';
import ProjectViewSummary from '@/components/project/common/ProjectViewSummary';
import ProjectEditHandsontable from '@/components/project/common/ProjectEditHandsontable';
import ProjectEditComment from '@/components/project/common/ProjectEditComment';
import { getProjectById, editProject } from '@/services/proj/bid-project-service';
import { listShop, saveShop, editShop, deleteShop } from '@/services/proj/bid-shopping-list-service';
import { cloneDeep } from 'lodash';
import $ from 'jquery';
export default {
  name: 'ProjBidNewPurchaseList',
  components: {
    ProjBidNewHeader,
    ProjectViewSummary,
    ProjectEditHandsontable,
    ProjectEditComment
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      project: {
        projectComment: ''
      },
      buttonLoading: false,
      user: this.$store.state.user.userInfo,
      initHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价', '删除'],
        allowInsertRow: true,
        renderAllRows: true,
        fillHandle: 'vertical',
        rowHeaderWidth: 40,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 200
          },

          {
            data: 'productDesc',
            type: 'text',
            width: 369
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 50,
            className: 'htCenter'
          },
          {
            data: 'productNum',
            width: 75,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric'
          },
          {
            data: 'shoppingPrice',
            width: 120,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            },
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
              $(td).css('background', '#f3f3f3');
              return td;
            }
          },
          {
            data: 'shoppingSubtotal',
            width: 110,
            className: 'htRight',
            type: 'numeric',
            readOnly: true,
            numericFormat: {
              pattern: '0,0.00'
            },
            renderer: function(instance, td, row, col, prop, value, cellProperties) {
              $(td).css('background', '#f3f3f3');
              return td;
            }
          },
          {
            data: 'removeRow',
            width: 40,
            readOnly: true,
            copyable: false,
            renderer: 'html',
            className: 'htCenter'
          }
        ]
      }
    };
  },
  created() {
    this.initShopList();
  },
  methods: {
    async initShopList() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([
          getProjectById({ projectId: this.projectId }),
          listShop(this.projectId)
        ]);
        if (data1.returnCode === '01') {
          this.project = data1.project;
        } else {
          this.$message.error('获取项目信息失败');
        }
        if (data2.returnCode === '01' || data2.returnCode === '00') {
          if (data2.shopList) {
            this.initHotSettings.data = data2.shopList;
          } else {
            this.initHotSettings.data = [{ productName: '' }];
          }
          setTimeout(() => {
            this.resetPanelHeight();
          }, 50);
        } else {
          this.$message.error('获取分项报价表信息失败');
        }
      } catch (error) {
        this.$message.error('初始化项目失败，请稍后重试');
      }
      this.$root.layout.isLoading = false;
    },
    async validateBeforeSave(isLink, isPrev) {
      let tmpData = this.initHotSettings.data;
      let isShowMsg = true;
      for (let i = 0; i < tmpData.length; i++) {
        if (tmpData[i].productNum > 0) {
          isShowMsg = false;
          break;
        }
      }
      if (isShowMsg) {
        this.$ebConfirm(
          '您的采购清单，“数量”一栏均为 0。由此会造成供应商报价结果计算为 0。建议您输入适当的“单位”，将“数量”填写为 1。选择“修改”按钮，返回修改；选择“忽略”按钮，忽略此问题。',
          '重要提示',
          {
            cancelButtonText: '返回修改',
            confirmButtonText: '忽略'
          }
        )
          .then(() => {
            this.saveOrEbidProject(isLink, isPrev);
          })
          .catch(() => {});
      } else {
        this.saveOrEbidProject(isLink, isPrev);
      }
    },
    async saveOrEbidProject(isLink, isPrev) {
      this.buttonLoading = true;
      let cloneData = cloneDeep(this.initHotSettings.data);
      let saveOrEditShopListArr = [];
      if (!this.validator(cloneData)) {
        this.buttonLoading = false;
        return false;
      }
      cloneData.forEach((el, index) => {
        delete el['removeRow'];
        if (el['productName'] || el['productDesc'] || el['productUnit'] || el['productNum']) {
          if (el['shoppingId']) {
            saveOrEditShopListArr.push(this.editShop(el, index));
          } else {
            saveOrEditShopListArr.push(this.saveShopList(el, index));
          }
        }
      });
      saveOrEditShopListArr.push(this.editProject());
      try {
        let dataArr = await Promise.all(saveOrEditShopListArr);
        this.initShopList();
        this.buttonLoading = false;
        if (this.returnCodeMessage(dataArr, isLink)) {
          if (isLink && !isPrev) {
            this.$router.push('/projbid/new/invitesupplier/' + this.projectId);
          } else if (isLink && isPrev) {
            this.$router.push('/projbid/new/ruleedit/' + this.projectId);
          }
        }
      } catch (error) {
        this.buttonLoading = false;
        this.$message.error('保存失败，请稍后重试');
      }
    },
    async removeRowEvent(returnData) {
      let hotData = this.initHotSettings.data[returnData.row];
      if (hotData && hotData['shoppingId']) {
        returnData.next(returnData.row);
        let { data } = await deleteShop({ removeId: this.user.userid, shoppingId: hotData['shoppingId'] });
        if (data.returnCode === '01') {
          this.$message.success('删除成功');
        } else {
          this.$message.error('删除失败');
        }
      } else {
        this.$message.success('删除成功');
        returnData.next(returnData.row);
      }
    },
    saveShopList: function(cloneData, index) {
      let data = {
        buyDepartId: this.user.departId,
        createId: this.user.userid,
        projectId: this.projectId,
        productName: cloneData['productName'] ? cloneData['productName'] : ' ',
        productDesc: cloneData['productDesc'] ? cloneData['productDesc'] : '',
        productUnit: cloneData['productUnit'] ? cloneData['productUnit'] : '',
        productNum: cloneData['productNum'] ? cloneData['productNum'] : 0,
        shoppingPrice: 0,
        shoppingSubtotal: 0,
        shoppingTotal: 0,
        produtCode: 3,
        sortIndex: index
      };
      return saveShop(data);
    },
    editShop: function(cloneData, index) {
      let data = {
        productName: cloneData['productName'] ? cloneData['productName'] : ' ',
        productDesc: cloneData['productDesc'] ? cloneData['productDesc'] : '',
        productUnit: cloneData['productUnit'] ? cloneData['productUnit'] : '',
        productNum: cloneData['productNum'] ? cloneData['productNum'] : 0,
        shoppingPrice: 0,
        shoppingSubtotal: 0,
        shoppingTotal: 0,
        sortIndex: index,
        shoppingId: cloneData['shoppingId'],
        updateId: this.user.userid
      };
      return editShop(data);
    },
    returnCodeMessage: function(dataArr, isLink) {
      dataArr.forEach(function(element, index) {
        if (element.data.returnCode === '01') {
        } else {
          this.$message.error('保存草稿失败');
          return false;
        }
      });
      if (!isLink) {
        this.$message.success('保存草稿成功');
      }
      return true;
    },
    editProject: function() {
      let params = {
        projectId: this.projectId,
        updateId: this.user.userid,
        projectComment: this.project.projectComment
      };
      return editProject(params);
    },
    validator: function(data) {
      var flag = true;
      data.forEach(el => {
        if ((el['productNum'] || el['productUnit']) && (!el['productName'] && !el['productDesc'])) {
          this.$message.error('名称和描述不能全为空');
          flag = false;
          return false;
        }
        if (el['productNum'] && isNaN(Number(el['productNum']))) {
          this.$message.error('请将数量修改为数字');
          flag = false;
          return false;
        }
        if (el['productUnit'] && el['productUnit'].length > 20) {
          this.$message.error('单位过长，请输入小于20字符的单位');
          flag = false;
          return false;
        }
      });
      return flag;
    },
    resetPanelHeight: function() {
      var lineHeight = $('#ebHansontable').height() + 30;
      $('#ebHansontable')
        .parents('.ebPanel')
        .height(lineHeight);
    }
  }
};
</script>

<style>
</style>
